export const useStoreCode = () => useState<string>('storeCode', () => '');